'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Modal = require('components/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _MyPlaylistsList = require('containers/MyPlaylists/components/MyPlaylistsList');

var _MyPlaylistsList2 = _interopRequireDefault(_MyPlaylistsList);

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _playlists = require('redux/modules/playlists');

var _MyPlaylistsSelectPopupFooter = require('components/MyPlaylistsSelectPopup/MyPlaylistsSelectPopupFooter');

var _MyPlaylistsSelectPopupFooter2 = _interopRequireDefault(_MyPlaylistsSelectPopupFooter);

var _myPlaylists2 = require('selectors/my-playlists');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _MyPLaylistsSearchBar = require('containers/MyPlaylists/components/MyPLaylistsSearchBar');

var _MyPLaylistsSearchBar2 = _interopRequireDefault(_MyPLaylistsSearchBar);

var _MyPlaylistsCreateBar = require('components/MyPlaylistsCreateBar/MyPlaylistsCreateBar');

var _MyPlaylistsCreateBar2 = _interopRequireDefault(_MyPlaylistsCreateBar);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistsSelectPopup.scss');

var scroll = _reactScroll2.default.animateScroll;
var listId = (0, _uuid2.default)();

var MyPlaylistsSelectPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    checkedPlaylists: (0, _myPlaylists2.getCheckedPlaylistsArray)(state),
    myPlaylists: (0, _myPlaylists2.getFilteredPlaylists)(state),
    myPlaylistsLoading: state.myPlaylists.myPlaylistsLoading,
    playlistsLoading: state.playlists.playlistsLoading
  };
}, (0, _extends3.default)({}, myPlaylistsActions, { isPlaylistsLoaded: _playlists.isLoaded, loadPlaylists: _playlists.loadPlaylists })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
  (0, _inherits3.default)(MyPlaylistsSelectPopup, _PureComponent);

  function MyPlaylistsSelectPopup() {
    var _ref;

    (0, _classCallCheck3.default)(this, MyPlaylistsSelectPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyPlaylistsSelectPopup.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsSelectPopup)).call.apply(_ref, [this].concat(args)));

    _this.state = { saving: false };
    return _this;
  }

  (0, _createClass3.default)(MyPlaylistsSelectPopup, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          isLoaded = _props.isLoaded,
          loadMyPlaylists = _props.loadMyPlaylists,
          myPlaylistsLoading = _props.myPlaylistsLoading,
          playlistsLoading = _props.playlistsLoading,
          show = _props.show;

      var isShowing = !prevProps.show && show;
      var needLoadMyPlaylists = !isLoaded() && !myPlaylistsLoading;
      var needLoadPlaylists = !this.props.isPlaylistsLoaded() && !playlistsLoading;

      if (isShowing) {
        if (needLoadMyPlaylists) {
          loadMyPlaylists();
        }
        if (needLoadPlaylists) {
          this.props.loadPlaylists();
        }
      }
    }
  }, {
    key: 'onHide',
    value: function onHide() {
      var _props2 = this.props,
          onHide = _props2.onHide,
          setMyPlaylistsFilter = _props2.setMyPlaylistsFilter;

      setTimeout(function () {
        return setMyPlaylistsFilter({ kw: '' });
      }, 300);
      onHide();
    }
  }, {
    key: 'onCreated',
    value: function onCreated() {
      scroll.scrollToBottom({ containerId: listId });
    }
  }, {
    key: 'save',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props3, onSave, checkedPlaylists, t;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props3 = this.props, onSave = _props3.onSave, checkedPlaylists = _props3.checkedPlaylists, t = _props3.t;

                this.setState({ saving: true });
                _context.next = 4;
                return onSave(checkedPlaylists);

              case 4:
                this.onHide();
                this.setState({ saving: false });
                _toastr2.default.success(t('Successfully saved!'));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _ref2.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          t = _props4.t,
          show = _props4.show,
          checkedPlaylists = _props4.checkedPlaylists,
          myPlaylistsLoading = _props4.myPlaylistsLoading,
          myPlaylists = _props4.myPlaylists;
      var saving = this.state.saving;

      var modalProps = {
        backdrop: true,
        closeByEsc: false,
        title: t('Add to My playlists'),
        bsSize: 'lg',
        withoutPadding: true
      };

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, modalProps, { show: show, onHide: this.onHide }),
        _react2.default.createElement(
          'div',
          { className: styles.topBars },
          _react2.default.createElement(_MyPlaylistsCreateBar2.default, {
            className: styles.addBar,
            disabled: myPlaylistsLoading,
            checkCreated: true,
            onCreated: this.onCreated
          }),
          _react2.default.createElement(_MyPLaylistsSearchBar2.default, { autoFocus: true })
        ),
        _react2.default.createElement(_MyPlaylistsList2.default, {
          loading: myPlaylistsLoading,
          playlists: myPlaylists,
          selectable: true,
          clickable: false,
          withOptions: false,
          withIndex: true,
          className: styles.list,
          id: listId
        }),
        _react2.default.createElement(_MyPlaylistsSelectPopupFooter2.default, {
          checkedCount: checkedPlaylists.length,
          onSave: this.save,
          loading: saving
        })
      );
    }
  }]);
  return MyPlaylistsSelectPopup;
}(_react.PureComponent), _class3.propTypes = {
  checkedPlaylists: _propTypes2.default.array,
  isLoaded: _propTypes2.default.func,
  isPlaylistsLoaded: _propTypes2.default.func,
  loadMyPlaylists: _propTypes2.default.func,
  loadPlaylists: _propTypes2.default.func,
  myPlaylists: _propTypes2.default.array,
  myPlaylistsLoading: _propTypes2.default.bool,
  onHide: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  playlistsLoading: _propTypes2.default.bool,
  setMyPlaylistsFilter: _propTypes2.default.func,
  show: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  checkedPlaylists: [],
  onHide: _noop3.default,
  onSave: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onHide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCreated', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCreated'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MyPlaylistsSelectPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyPlaylistsSelectPopup/MyPlaylistsSelectPopup.js
// module id = 2033
// module chunks = 1